import { Box, Flex, useToken } from "@chakra-ui/react";
import { skinColors, cheeks } from "src/modules/avatar/baby-customization";
import SkinColorSelector from "src/modules/avatar/scenes/Editor/SkinColorSelector";
import { Lottie } from "src/components/Lottie";

import { BodyText2 } from "src/atoms/typography";

import cheeks0 from "./Cheeks0.json";
import cheeks1 from "./Cheeks1.json";
import cheeks2 from "./Cheeks2.json";

const animations = [cheeks0, cheeks1, cheeks2];

function CheekSelector({ children, skinColor, isSelected, onClick, ...rest }) {
  const surfaceElevated1 = useToken("colors", "surfaceElevated1");
  const primary = useToken("colors", "primary");
  return (
    <Flex
      onClick={onClick}
      justifyContent="center"
      bg={skinColor}
      alignItems="center"
      width="32px"
      borderRadius="100%"
      height="32px"
      boxShadow={
        isSelected
          ? `0 0 0 2pt ${surfaceElevated1},0 0 0 4pt ${primary}`
          : undefined
      }
      {...rest}
    >
      {children}
    </Flex>
  );
}

export default function Skin({
  handleAvatarStyleUpdate,
  avatar,
  onSkinSelect,
  t
}) {
  const { avatarCustomization, moreDataJson } = avatar;
  const { cheek } = avatarCustomization;
  const skinColor =
    skinColors[avatarCustomization?.skinColor]?.BaseSkin ||
    skinColors[moreDataJson.skinColor]?.BaseSkin;
  const cheekColor =
    skinColors[avatarCustomization?.skinColor || moreDataJson?.skinColor]
      ?.DarkSkin;
  const cheekCss = Object.values(cheeks).reduce((result, layers) => {
    layers.forEach((layer) => {
      result =
        result +
        `
  & .${layer} {
    fill: ${cheekColor};
  }
  `;
    });
    return result;
  }, "");
  return (
    <Box pt="16px">
      <SkinColorSelector
        t={t}
        selectedColor={
          avatarCustomization?.skinColor || moreDataJson?.skinColor
        }
        onChange={onSkinSelect}
      />
      <BodyText2 mt="16px" mb="8px" color="highEmphasis">
        {t("avatar.frecklesAndBlush")}
      </BodyText2>
      <Flex
        gap="12px"
        css={`
          ${cheekCss}
        `}
      >
        <CheekSelector
          onClick={() => handleAvatarStyleUpdate({ cheek: "NO_CHEEK" })}
          isSelected={"NO_CHEEK" === cheek}
          skinColor={skinColor}
        />
        {animations.map((animation, i) => {
          return (
            <CheekSelector
              key={i}
              skinColor={skinColor}
              onClick={() => handleAvatarStyleUpdate({ cheek: `CHEEK_${i}` })}
              isSelected={`CHEEK_${i}` === cheek}
            >
              <Lottie
                animationData={animation}
                browserProps={{ hasRawData: true }}
              />
            </CheekSelector>
          );
        })}
      </Flex>
    </Box>
  );
}
